import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCSydney = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agency Sydney | AI UGC Creator Australia | Fuel72</title>
        <meta
          name="description"
          content="UGC Agency Sydney: Professional AI UGC videos for Australian businesses. UGC Creator Sydney without influencers. 72-hour delivery. ✓ Local ✓ Fast ✓ Affordable"
        />
        <meta
          name="keywords"
          content="ugc agency sydney, ugc creator australia, ugc sydney, ai ugc australia, ugc videos sydney, content creator australia, ugc advertising australia"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-sydney" />
        
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/ugc-sydney" />
        <link rel="alternate" hrefLang="en-AU" href="https://www.fuel72.com/ugc-sydney" />
        <link rel="alternate" hrefLang="x-default" href="https://www.fuel72.com/ugc-sydney" />
        
        <meta property="og:title" content="UGC Agency Sydney | AI UGC Creator Australia | Fuel72" />
        <meta property="og:description" content="AI UGC videos for Australian businesses. Fast, professional, affordable." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-sydney" />
        <meta property="og:locale" content="en_AU" />
        
        <meta name="geo.region" content="AU-NSW" />
        <meta name="geo.placename" content="Sydney" />
        <meta name="geo.position" content="-33.8688;151.2093" />
        <meta name="ICBM" content="-33.8688, 151.2093" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agency Sydney",
            "description": "Professional AI UGC videos for Sydney and Australian businesses. Create UGC content without filming.",
            "url": "https://www.fuel72.com/ugc-sydney",
            "telephone": "+4917687870011",
            "email": "hello@fuel72.com",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Sydney",
              "addressRegion": "NSW",
              "addressCountry": "AU"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "-33.8688",
              "longitude": "151.2093"
            },
            "areaServed": { "@type": "City", "name": "Sydney" },
            "priceRange": "$$"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agency{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              Sydney
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Professional AI UGC videos for Australian businesses. 
            E-commerce, hospitality, fitness – we make you visible.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC for Australian Businesses</h2>
            <p className="text-muted-foreground">
              Sydney leads Australia's digital economy. With Fuel72, Aussie businesses get 
              professional UGC videos that convert on Instagram, TikTok and Meta Ads – 
              without the cost of local influencers.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Industries in Sydney</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>🛍️ E-Commerce & Retail</li>
              <li>🍔 Restaurants & Hospitality</li>
              <li>💪 Fitness & Wellness</li>
              <li>💇 Beauty & Skincare</li>
              <li>🏠 Real Estate</li>
              <li>🚀 Tech & Startups</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Why Fuel72 for Sydney?</h2>
            <ul className="space-y-3 text-muted-foreground">
              <li>✅ <strong>Cheaper</strong> – $397 AUD instead of $600-2500 per creator</li>
              <li>✅ <strong>Faster</strong> – 72 hours instead of weeks</li>
              <li>✅ <strong>Scalable</strong> – Unlimited content production</li>
              <li>✅ <strong>No risk</strong> – Consistent quality every time</li>
            </ul>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Redirecting to main page...</p>
        </div>
      </main>
    </>
  );
};

export default UGCSydney;